import { AfterViewInit, Component, ElementRef, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import Tooltip from 'bootstrap/js/dist/tooltip';
import { ELoadingIndicatorStyle } from 'projects/shared/lib/enum/loading/loading-indicator-style.enum';
import { EProductAvailabilityState } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { ITooltipService, ITooltipServiceToken } from 'shared/services/ui/tooltip/tooltip-service.interface';

@Component({
  template: '',
  standalone: false
})
export class ProductAvailabilityBaseComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() productAvailabilityState?: EProductAvailabilityState | undefined;
  public isLoading: boolean;

  public knownAvailabilityStates = EProductAvailabilityState;
  public eLoadingIndicatorStyle: typeof ELoadingIndicatorStyle;

  @ViewChild('availabilityTooltipContainer') availabilityTooltipContainerRef: ElementRef<HTMLSpanElement> | undefined;
  public availabilityTooltipHtmlContent: string | undefined;
  private availabilityTooltip: Tooltip | undefined;
  private readonly toolTipService: ITooltipService = inject(ITooltipServiceToken);

  public constructor() {
    this.isLoading = true;
    this.eLoadingIndicatorStyle = ELoadingIndicatorStyle;
  }

  public ngOnInit(): void {
    this.availabilityTooltipHtmlContent = this.toolTipService.availabilityToolTipGet();
  }

  ngAfterViewInit() {
    if (this.availabilityTooltipContainerRef) {
      this.availabilityTooltip = new Tooltip(this.availabilityTooltipContainerRef.nativeElement);
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    for (let propName in changes) {
      switch (propName) {
        case 'productAvailabilityState':
          this.isLoading = false;
          break;
        default:
          this.isLoading = false;
          break;
      }
    }
  }

  public ngOnDestroy(): void {
    this.availabilityTooltip?.dispose();
    this.isLoading = false;
  }
}
